import React from "react"
import { Link } from "lib"

const LinkRenderer = ({ domRef, info, value, children, ...props }) => {
    if (!value) return null

    return (
        <Link domRef={domRef} {...props} to={value.path || ""}>
            {value.label || ""}
            {children}
        </Link>
    )
}
export default React.memo(LinkRenderer)
